import { __extends } from "tslib";
import { GetCampaignsRequest, GetCampaignsResponse } from "../models/index";
import { deserializeAws_restJson1GetCampaignsCommand, serializeAws_restJson1GetCampaignsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetCampaignsCommand = /** @class */ (function (_super) {
    __extends(GetCampaignsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetCampaignsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetCampaignsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetCampaignsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetCampaignsResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCampaignsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetCampaignsCommand(input, context);
    };
    GetCampaignsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetCampaignsCommand(output, context);
    };
    return GetCampaignsCommand;
}($Command));
export { GetCampaignsCommand };
//# sourceMappingURL=GetCampaignsCommand.js.map